export default __webpack_public_path__ + "static/media/undraw_Business_decisions_re_84ag.7fb34b6a.svg";